<template>
  <div class="product-show-box">
    <Banner :banner-h="banenrH1" :style-height="styleHeight" :banner-img="banenrImg"></Banner>

    <scroll-animate>
      <!--    设备展示 -->
      <div class="product-show core_box">
        <div class="product clearfix">
          <!--        <div class="product-left">-->
          <!--          <h1>{{ product.categoryName }}</h1>-->
          <!--          <div class="product-left-button">-->
          <!--&lt;!&ndash;            <span class="el-icon-arrow-left" @click="arrowLeft($event)"/>&ndash;&gt;-->
          <!--&lt;!&ndash;            <span class="el-icon-arrow-right" @click="arrowRight($event)"/>&ndash;&gt;-->

          <!--            <el-progress type="dashboard" :percentage="percentage"></el-progress>-->
          <!--            <div>-->
          <!--              <el-button-group>-->
          <!--                <el-button icon="el-icon-arrow-left" @click="arrowLeft"></el-button>-->
          <!--                <el-button icon="el-icon-arrow-right" @click="arrowRight"></el-button>-->
          <!--              </el-button-group>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->

          <div class="product-right">
            <ul class="clearfix" style="left: 0px;">
              <li v-for="(item,index) in product.catgItem" :key="index">
                <img :src="item.catgImg"/>
                <span>{{ item.name }}</span>
                <p>{{ item.text }}</p>
                <button @click="productInfo(item)">{{ $t('productShow.showInfo') }}</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </scroll-animate>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import ScrollAnimate from "./ScrollAnimate.vue";

export default {
  components: {ScrollAnimate, Banner},
  data() {
    return {
      banenrImg: require("@/assets/img/banner-bg/bananer-bg.png"),
      banenrH1: "产品展示",
      styleHeight: {
        height: "300px",
      },
      wiperL: 0,
      wiperR: 0,
      percentage: 0,
      accountedFor: 0,
      product: {},
    }
  },
  methods: {
    productInfo(data) {
      this.$router.push({
        name: 'productInfoShow',
        query: {
          item: data.id
        }
      })
    }
  },
  mounted() {
    // 产品赋值
    const dataStorage = JSON.parse(sessionStorage.getItem("product"))
    this.product.categoryName = dataStorage.name
    this.product.catgItem = dataStorage.options
    this.banenrH1 = this.product.categoryName

    // const productUlLiLength = $(".product-right ul li").length
  }
}
</script>

<style scoped lang="scss">
.product-show-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.product-show {
  width: 100vw;
  //min-width: 750px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1600px) {
  .product {
    justify-content: normal !important;
  }
}

.product {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 90%;
  //min-width: 750px;
  //margin: 0 auto;
  margin-top: 3rem;

  /*.product-left {
    float: left;
    width: 20%;
    padding: 2rem 0;

    h1 {
      text-align: center;
      color: #333333;
      margin-top: 5rem;
    }

    .product-left-button {

      text-align: center;

      span {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        background-color: #f2f2f2;
        margin-left: 0.5rem;
        margin-top: 2rem;
        padding: 0.3rem;
        border: 1px solid #ababab;
        cursor: pointer;
        text-align: center;
        line-height: 2rem;
        font-size: 2rem;
        color: #8c8c8c;
        transition: all ease-in 0.2s;

        &:hover {
          background-color: $shanMai_blue;
          color: #ffffff;
        }
      }
    }
  }*/

  .product-right {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;

    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      transition: all ease .3s;

      li {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 29rem;
        width: 19.5rem;
        background-color: white;
        margin-left: 1rem;
        margin-top: 2rem;
        padding: 2rem;
        box-sizing: border-box;
        //border: 1px solid #ababab;
        border-radius: 1rem;
        //box-shadow: 0 1px 1px #ababab;
        box-shadow: 0px 0px 10px rgba(157, 179, 208, 0.4);
        cursor: pointer;
        user-select: none;
        transition: all ease-in .1s;
        overflow: hidden;

        &:hover {
          transform: translateY(-1rem);
          //box-shadow: 0 0.5rem 0 #ababab;
          box-shadow: 0 0.5rem 0 rgba(157, 179, 208, 0.4);
        }

        img {
          height: 10rem;
          object-fit: cover;
          overflow: hidden;
        }

        span {
          display: block;
          text-align: center;
          color: $shanMai_blue;
        }

        p {
          margin-top: 2rem;
          color: #8e8e8e;
          font-size: .8rem;
          line-height: 1.9;
        }

        button {
          width: 7rem;
          height: 2rem;
          bottom: 2rem;
          border: 1px solid #7d7d7d;
          color: #666666;
          font-size: 0.8rem;
          background-color: white;
          transition: all ease .2s;
          cursor: pointer;
          border-radius: 0.3rem;

          &:hover {
            background-color: $shanMai_blue;
            color: white;
          }
        }
      }

      @media screen and (max-width: 720px) {
        justify-content: center;
      }
    }


    .progress-bar {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 222;
      width: 63.5%;
      height: 0.5rem;

      span {
        display: block;
        height: 0.1rem;
      }
    }
  }


}
</style>
